import Select from 'react-select'
import { Button, Col, Form } from "react-bootstrap";
import { Link,withRouter } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import "../../../css/newitempage.css"
import { generateErrorMessage, logOut, make_select_data } from "../../helper";
import React, {Component} from 'react';
class NewRole extends Component{
    constructor(){
        super();
        this.state = {
            name: "",
            display_name:"",
            perrmissions_array:[],
            selected_permissions:[],
            managers_array:[],
            selected_managers:[],
            errors:{
                name:false,
                display_name:false
            },
            modal:false,
            error_messages:{
                name_error_message:"გთხოვთ შეიყვანოთ როლი",
                display_name_error_message:'გთხოვთ შეიყვანოთ როლი',
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'როლი წარმატებით ჩაემატა'
            }
        }
    }
    componentDidMount(){
        this.fetch_permissions();
        this.fetch_roles();
        let role_id = this.props.match.params.id
        if(role_id){
            this.fetch_role_permissions(role_id);
            this.fetch_role_displayname(role_id);
            this.fetch_role_managers(role_id);
        }
    }


    fetch_role_managers(role_id){
        axiosInstance.get('/roles/'+role_id+'/managers')
        .then(response=>{
            this.setState({
                selected_managers:make_select_data(response.data.data)
            })
        })
        .catch(err => {
            console.log(err)
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }

    fetch_roles(){
        axiosInstance.get('/roles')
        .then(response=>{
            this.setState({
                managers_array:make_select_data(response.data.data)
            })
        })
        .catch(err => {
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }




    fetch_role_displayname(role_id){
        axiosInstance.get('/roles/'+role_id)
        .then(response=>{
            this.setState({
                name:response.data.data.name,
                display_name:response.data.data.display_name
            });
        })
        .catch(err => {
            console.log(err)
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }
    
    onChange(event){
        this.setState(
            {[event.target.name]:event.target.value,
                errors:{
                    ...this.state.errors,
                    [event.target.name]:false 
                },
                response : {
                    isValid : false,
                    isInValid:false,
                    message : 'როლი წარმატებით ჩაემატა'
                }
            }
        ) 
    }

    fetch_role_permissions(role_id){
        axiosInstance.get('/roles/'+role_id+'/permissions')
        .then(response=>{
            this.setState({
                selected_permissions:make_select_data(response.data.data)
            })
        })
        .catch(err => {
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }
    on_role_added(data){
        this.setState({
            response:{
                ...this.state.response,
                isValid:true,
                message:data.message
            }
        })
    }
    add_role_btn_clicked(event){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:false,
                isValid:false,
                message:''
            }
        })

        if(this.valid()){
            axiosInstance.post('/roles', {
                "name" : this.state.name,
                "display_name":this.state.display_name,
                "permissions_ids":this.state.selected_permissions.map(x => x.value),
                "manager_role_ids":this.state.selected_managers.map(x => x.value)
            })
            .then(response=>{
                this.setState({
                    response:{
                        ...this.state.response,
                        isValid:true,
                        message:response.data.message
                    }
                })
            })
            .catch(error => {
                if(error.response?.status == 400 || error.response?.status == 422){
                    this.on_bad_request(error);
                }
            });
        }
    }

    valid(){
        var name = (this.state.name === "");
        var display_name = (this.state.display_name === "");
        if(name || display_name){
            this.setState({
                errors:{
                    name:name,
                    display_name:display_name
                },
            })
            return false;
        }
        return true;
    }

    on_bad_request(error){
        let message = generateErrorMessage(error.response.data.errors);
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:message
            }
        })
    }


    fetch_permissions(){
        axiosInstance.get('roles/permissions')
        .then(response=>{
            this.setState({
                perrmissions_array:make_select_data(response.data.data)
            })
        })
        .catch(err => {
            console.log(err)
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }
    on_permission_change(e){
        this.setState({
            selected_permissions:e
        });
    }
    on_managers_change(e){
        this.setState({
            selected_managers:e
        });
    }

    update_role_btn_clicked(){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:false,
                isValid:false,
                message:''
            }
        })
        axiosInstance.put('/roles/'+this.props.match.params.id,{
            "name" : this.state.name,
            "display_name":this.state.display_name,
            "permissions_ids":this.state.selected_permissions.map(x => x.value),
            "manager_role_ids":this.state.selected_managers.map(x => x.value)
        })
        .then(response=>this.on_role_updated(response.data))
        .catch(error => {
            if(error.response.status == 400){
                this.on_bad_request(error);
            }
        });

    }
    on_role_updated(data){
        this.setState({
            response:{
                ...this.state.response,
                isValid:true,
                message:data.message
            }
        })
    }
    render(){
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    type="text"
                                    name="role"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  sm="12" md="4" >
                            <Form.Label>სახელი ლათინურად</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.name)}
                                    value = {this.state.name}
                                    disabled = {this.props.match.params.id}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.name_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  sm="12" md="4" >
                            <Form.Label>გამოსაჩენი სახელი</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="display_name"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.display_name)}
                                    value = {this.state.display_name}
                                    disabled = {this.props.match.params.id}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.display_name_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col} sm="12" md="9" lg="7" >
                            <Form.Label>უფლებები</Form.Label>
                            <Form.Control
                                    type="text"
                                    name="role"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.errors.role)}
                                    onChange = {null}
                                />
                            <Select 
                                value = {this.state.selected_permissions}
                                options={this.state.perrmissions_array} 
                                onChange={(e)=>this.on_permission_change(e) } 
                                placeholder = "აირჩიეთ უფლებები"
                                isMulti = {true}
                             />
                            <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.role_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col} sm="12" md="9" lg="7" >
                            <Form.Label>მენეჯერები</Form.Label>
                            <Form.Control
                                    type="text"
                                    name="role"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.errors.role)}
                                    onChange = {null}
                                />
                            <Select 
                                value = {this.state.selected_managers}
                                options={this.state.managers_array} 
                                onChange={(e)=>this.on_managers_change(e) } 
                                placeholder = "აირჩიეთ მენეჯერები"
                                isMulti = {true}
                             />
                            <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.role_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Link  to = "/roles"  id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                {this.props.match.params.id && <Button className="btn btn-success"  size="md" onClick={(event)=>this.update_role_btn_clicked(event)}>რედაქტირება</Button>}
                {!this.props.match.params.id && <Button className="btn btn-success"  size="md" onClick={(event)=>this.add_role_btn_clicked(event)}>დამატება</Button>}
            </div>
        )
    }
}
export default withRouter(NewRole);